<template>
  <div class="component-set-apportion">
    <div class="store-select">
      <el-form-item label="使用范围" prop="useRangeType">
        <el-radio-group v-model="form.useRangeType" @change="onUseRangeChange" :disabled="!!form.brandRefId">
          <el-radio label="Generic" v-if="isAdmin">{{ form.suitObject == 'sku'? '全场通用' : '店铺通用'}}</el-radio>
          <el-radio label="Mall">指定商场</el-radio>
          <el-radio label="Store" v-if="form.suitObject != 'sku'">指定店铺</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.useRangeType === 'Mall'" prop="mallIds" key="mallIds" label="" label-width="260px">
        <el-select v-model="form.mallIds" placeholder="请选择商场" @change="onAssignedChange('mallIds')" multiple filterable collapse-tags>
          <el-option v-for="item in mallData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.useRangeType === 'Store'" prop="storeIds" key="storeIds" label="" label-width="370px">
        <el-cascader
          v-model="form.storeIds"
          placeholder="请选择店铺"
          :options="shopTreeData"
          :props="shopCascaderProps"
          clearable
          collapse-tags
          :filterable="true"
          :show-all-levels="false"
          @change="onAssignedChange('storeIds')"
        >
        </el-cascader>
      </el-form-item>
    </div>
    <div  v-if="form.supplier!='VoucherCenter' && form.suitObject != 'sku'">
      <div class="title">
        <span>分摊设置</span>
        <span class="title-remark">（商场与店铺分摊优惠券费用，双方承担总费用为100%）</span>
      </div>
      <el-form-item label="默认商场承担比例" prop="mallCostRate" >
        <el-input type="text" v-model="form.mallCostRate" @blur="onMallCostRateBlur" oninput="value=value.replace(/[^.\d.]/g,'')" >
          <template slot="append">%</template>
        </el-input>
      </el-form-item>
      <div class="store-table-box">
        <div class="list-box">
          <div class="search-box">
            <el-row>
              <el-col :span="8">
                <el-form-item label="店铺名称" label-width="100px">
                  <el-input type="text" v-model="searchForm.name" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="商场名称" label-width="100px">
                  <el-input type="text" v-model="searchForm.mallName" />
                </el-form-item>
              </el-col>
              <el-col class="search-btn" :span="8">
                <el-button type="primary" class="mr10" @click="onSearch">查询</el-button>
                <el-button class="" @click="resetSearchForm">重置</el-button>
              </el-col>
            </el-row>
          </div>
          <Table
            :tableThData="tableThData"
            :tableTrData="tableTrData"
            :loading="loading"
            :limit="limit"
            :offset="offset"
            :total="total"
            v-on:handleSizeChange="handleSizeChange"
            v-on:handleCurrentChange="handleCurrentChange"
          >
            <template #name="{ row }">{{ row.name }}</template>
            <template #mallName="{ row }">{{ row.mallName }}</template>
            <template #costRate_mall="{ row }">{{ row.costRate_mall+'' ? row.costRate_mall+'%' : '---' }}</template>
            <template #costRate="{ row, scope }">
              <el-form-item label-width="0" prop="costRate" >
                <el-input type="text" v-model="tableTrData[scope.$index].costRate" @blur="() => onStoreRateBlur(row)" oninput="value=value.replace(/[^.\d.]/g,'')" style="width: 150px;" >
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </template>
          </Table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Table from "@/components/Table/index";
import { api_getStoreList } from "@/api/integral";

export default {
  name: "componentSetApportion",
  components: {
    Table
  },
  props: {
    form: {
      type: Object,
      default() {
        return {}
      },
    },
    isAdmin: {
      type: Boolean,
      default() {
        return false
      }
    },
    mallData: {
      type: Array,
      default() {
        return []
      }
    },
    shopTreeData: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      renderData: [
        {
          label: "店铺名称",
          placeholder: "请输入店铺名称",
          type: "input",
          key: "name",
        },
        {
          label: "商场名称",
          placeholder: "请输入商场名称",
          type: "input",
          key: "mallName",
        },
      ],
      useRangeType_last: '',
      searchForm: {},
      shopCascaderProps: { multiple: true, value: "id", label: "name", emitPath: false, }, // 店铺级联框配置项
      loading: false,
      tableThData: [
        { prop: "name", label: "店铺名称", minWidth: "120", },
        { prop: "mallName", label: "商场名称", minWidth: "120", },
        { prop: "costRate_mall", label: "商场承担比例", minWidth: "100", },
        { prop: "costRate", label: "店铺承担比例（为空或不填则取根据商场承担比例自动计算）", minWidth: "200", },
      ],
      tableData_all_search: [],
      tableData_all: [],
      tableTrData: [],
      limit: 10,
      offset: 0,
      total: 0,
      storeApiTimer: null,
    };
  },
  created() {
    this.getDetail() // 获取回显数据
  },
  mounted() {},
  methods: {
    // 获取回显数据
    getDetail() {
      if (this.$route.query.id) {
        if (this.form.id) {
          this.useRangeType_last = this.form.useRangeType
          this.tableData_all = this.form.storeCostRates
          this.getStoreData_all()
        } else {
          setTimeout(() => {
            this.getDetail()
          }, 100)
        }
      }
    },

    // 使用范围改变
    onUseRangeChange(value) {
      console.log('value: ', value);
      this.form.useRangeType = this.useRangeType_last
      if (this.tableData_all.length) {
        this.$baseConfirm(
          `当前已选择的店铺将会清空，是否切换？`,
          {title: '提示', type: 'warning',},
          async () => {
            this.useRangeChangeConfirm(value)
          },
        )
      } else {
        this.form.useRangeType = this.useRangeType_last = value
        delete this.form.mallIds
        delete this.form.storeIds
        value === 'Generic' && this.getStoreData_all() // 获取店铺通用的所有店铺数据
      }
    },

    // 确认切换适用范围
    useRangeChangeConfirm(value) {
      this.clearTableData() // 清空店铺表格
      this.form.useRangeType = this.useRangeType_last = value
      delete this.form.mallIds
      delete this.form.storeIds
      value === 'Generic' && this.getStoreData_all() // 获取店铺通用的所有店铺数据
    },

    // 获取店铺列表数据
    getStoreData_all() {
      this.loading = true
      clearTimeout(this.storeApiTimer)
      this.storeApiTimer = setTimeout(async() => {
        try {
          this.limit = 10
          this.offset = this.total = 0
          let res = await api_getStoreList({
            ids: this.form.storeIds || [],
            mallIds: this.form.mallIds || []
          })
          let haveSetRate = this.tableData_all.filter(item => !!(item.costRate+''))
          let haveSetRateIds = haveSetRate.map(item => item.storeId)
          res.forEach(item => {
            item.storeId = item.id
            // 已有店铺承担比例的数据，店铺承担比例、商场承担比例保持不变
            if (haveSetRateIds.indexOf(item.storeId) >= 0) {
              let cur = haveSetRate.filter(el => el.storeId == item.storeId)
              item.costRate = cur[0].costRate
              item.costRate_mall = this.computeNum(100 - cur[0].costRate)
            } else {
              item.costRate = '' // 店铺承担比例
              item.costRate_mall = this.form.mallCostRate || '' // 商场承担比例
            }
          })
          this.tableData_all = res
          console.log('res: ', res);
          this.getList()
          this.loading = false
        } catch(err) {
          this.loading = false
        }
      }, 500)
    },

    // 商场默认比例失焦
    onMallCostRateBlur() {
      this.resetSearchForm()
      this.form.mallCostRate = parseFloat(this.form.mallCostRate) >= 100 ? 100 : this.form.mallCostRate
      this.tableData_all = this.tableData_all.map(item => {
        if (!item.costRate) {
          item.costRate_mall = this.form.mallCostRate || ''
        }
        return item
      })
    },

    // 店铺承担比例失焦
    onStoreRateBlur(row) {
      // 自动计算该行商场承担比例
      let currentIndex = this.tableData_all.findIndex(item => item.id == row.id)
      let currentRow = this.tableData_all[currentIndex]
      if (parseFloat(currentRow.costRate) >= 100) {
        this.tableData_all[currentIndex].costRate = currentRow.costRate = 100
        this.tableData_all[currentIndex].costRate_mall = '0'
      } else {
        this.tableData_all[currentIndex].costRate_mall = currentRow.costRate ? this.computeNum(100 - currentRow.costRate) : this.form.mallCostRate
      }
      this.form.storeCostRates = this.tableData_all
    },

    // 指定商场或指定店铺下拉框改变
    onAssignedChange(field) {
      this.resetSearchForm()
      this.form[field].length ? this.getStoreData_all() : this.clearTableData()
    },

    // 清空店铺表格
    clearTableData() {
      this.tableData_all = this.tableTrData = []
      this.limit = 10
      this.offset = this.total = 0
    },

    onSearch() {
      const { name='', mallName='' } = this.searchForm
      if (name || mallName) {
        if (this.tableData_all_search.length) this.tableData_all = this.tableData_all_search
        if (!this.tableData_all_search.length) this.tableData_all_search = this.tableData_all
        let result = this.tableData_all
        name && (result = result.filter(item => item.name.indexOf(name) >= 0))
        mallName && (result = result.filter(item => item.mallName.indexOf(mallName) >= 0))
        this.tableData_all = result
        this.getList()
      } else {
        this.resetSearchForm()
      }
    },

    getList() {
      this.tableTrData = this.tableData_all.slice(this.offset, this.offset + this.limit)
      this.total = this.tableData_all.length
    },

    resetSearchForm() {
      this.searchForm = {}
      this.limit = 10
      this.offset = this.total = 0
      if (this.tableData_all_search.length) this.tableData_all = this.tableData_all_search
      this.getList()
    },

    // 处理js计算精度问题
    computeNum(i) {
      return parseFloat((i).toFixed(10))
    },

    // 列表分页
    handleSizeChange(limit) {
      this.limit = limit
      this.getList()
    },
    handleCurrentChange(offset) {
      this.offset = offset
      this.getList()
    }
  },

  watch: {
    tableData_all () {
      this.form.storeCostRates = this.tableData_all
    },
  }
};
</script>

<style lang="scss" scoped>
.component-set-apportion {

  .title {
    margin: 0;
    margin-bottom: 30px;
    padding-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    .title-remark {
      color: #666666;
      font-size: 14px;
    }

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }
  }

  .store-table-box {
    border: 1px solid #ccc;
    border-radius: 5px;
    min-height: 100px;
    padding: 20px;
    background: #eeeeee5d;
    margin-bottom: 20px;

    .list-box {
      padding: 10px;
      background: #fff;
      border-radius: 5px;

      .search-box {
        .search-btn {
          text-align: right;
        }
        .el-input {
          width: 200px;
        }
      }

      ::v-deep .el-form-item {
        margin: 0;
      }

      ::v-deep .el-pagination {
        margin: 0;
        margin-top: 20px;

        .el-select,
        .el-input {
          width: 100px;
        }
      }
    }
  }
}
</style>
